import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    // Datos basicos del usuario
    usuario: "",
    userMail: "",
    nombre: "",
    userId: null,
    role: "",

    // Tokens de autenticacion
    accessToken: null,
    refreshToken: null,
    tokenExpiry: null,
    // Momento del login real (no se actualiza en cada refresh de token) -
    // usado para el auto-logout proactivo a las N horas, ver
    // initSessionWatchdog() en utils/authSession.js.
    loginAt: null,

    // Preferencias de usuario TimeSheet
    rowMode: 0,
    timeInterval: 30,
    timeTipo: 0,
    confirmDelete: 1,
    repiteTarea: 0,
    viewTorta: 0,

    // UI
    sidebarCollapsed: true,

    // Estado de datos del store viejo
    selTareas: [],
    copyTareas: [],
    rowExpanding: [],
    isExpanding: 0,
    title: "Timesheet",
  }),

  getters: {
    isAuthenticated: (state) => !!state.accessToken,
    isAdmin: (state) => state.role === "admin",
    isTokenValid: (state) => {
      if (!state.accessToken || !state.tokenExpiry) return false;
      const now = Date.now();
      const expiryTime = new Date(state.tokenExpiry).getTime();
      const fiveMinutes = 5 * 60 * 1000;
      return now < expiryTime - fiveMinutes;
    },
    userInfo: (state) => ({
      usuario: state.usuario,
      nombre: state.nombre,
      userId: state.userId,
      role: state.role,
    }),
  },

  actions: {
    setUsuario(value) {
      this.usuario = value;
    },
    setUserMail(value) {
      this.userMail = value;
    },
    setNombre(value) {
      this.nombre = value;
    },
    setUserId(value) {
      this.userId = value;
    },
    setRole(value) {
      this.role = value;
    },
    setTokens({ accessToken, refreshToken, expiry }) {
      this.accessToken = accessToken;
      this.refreshToken = refreshToken;
      this.tokenExpiry = expiry;
    },
    setLoginAt(value) {
      this.loginAt = value;
    },
    clearTokens() {
      this.accessToken = null;
      this.refreshToken = null;
      this.tokenExpiry = null;
    },
    setRowMode(value) {
      this.rowMode = value ?? 0;
    },
    setTimeInterval(value) {
      this.timeInterval = value ?? 30;
    },
    setTimeTipo(value) {
      this.timeTipo = value ?? 0;
    },
    setConfirmDelete(value) {
      this.confirmDelete = value ?? 1;
    },
    setRepiteTarea(value) {
      this.repiteTarea = value ?? 0;
    },
    setViewTorta(value) {
      this.viewTorta = value ?? 0;
    },
    setSelTareas(value) {
      this.selTareas = value;
    },
    setCopyTareas(value) {
      this.copyTareas = value;
    },
    setRowExpanding(value) {
      this.rowExpanding = value;
    },
    setIsExpanding(value) {
      this.isExpanding = value;
    },
    setTitle(value) {
      this.title = value;
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    resetAuth() {
      this.usuario = "";
      this.userMail = "";
      this.nombre = "";
      this.userId = null;
      this.role = "";
      this.accessToken = null;
      this.refreshToken = null;
      this.tokenExpiry = null;
      this.loginAt = null;
    },
  },

  persist: {
    storage: localStorage,
    paths: [
      "accessToken",
      "refreshToken",
      "tokenExpiry",
      "loginAt",
      "usuario",
      "userMail",
      "nombre",
      "userId",
      "role",
      "sidebarCollapsed",
    ],
  },
});
